import { Api } from '../api';
import { cards } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  BackgroundTasksResponse,
  CardDetailsResponse,
  CreditLimitsResponse,
  CardResponse,
  CardsRequest,
  RemindPinRequest,
  RemindPinResponse,
  ReportLostStolenRequest,
  UpdateCategoryCardRequest,
  UpdateDebitLimitResponse,
  UpdateDebitLimitRequest,
  UpdateLabelCardRequest,
  UpdateCreditLimitRequest,
  DebitLimitResponse,
} from './models';

export class CardsApi extends Api {
  static getCards = (request: CardsRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<CardResponse[]>>({ url: cards.getCards(), queryParams: request, signal });

  static getCard = (cardId: number, signal?: AbortSignal) => this.get<ApiResponse<CardDetailsResponse>>({ url: cards.getCard(cardId), signal });

  static getCreditLimit = (cardId: number, signal?: AbortSignal) =>
    this.get<ApiResponse<CreditLimitsResponse>>({ url: cards.getCreditLimit(cardId), signal });

  static getDebitLimit = (cardId: number, signal?: AbortSignal) =>
    this.get<ApiResponse<DebitLimitResponse>>({ url: cards.getDebitLimit(cardId), signal });

  static freezeCard = (cardId: number, signal?: AbortSignal) =>
    this.put<null, ApiResponse<CardDetailsResponse>>({ url: cards.freezeCard(cardId), signal });

  static unfreezeCard = (cardId: number, signal?: AbortSignal) =>
    this.put<null, ApiResponse<CardDetailsResponse>>({ url: cards.unfreezeCard(cardId), signal });

  static remindPin = (request: RemindPinRequest, signal?: AbortSignal) =>
    this.post<RemindPinRequest, ApiResponse<RemindPinResponse>>({ url: cards.remindPin(request.cardId), data: request, signal });

  static updateLabelCard = (request: UpdateLabelCardRequest, signal?: AbortSignal) =>
    this.put<UpdateLabelCardRequest, ApiResponse<CardDetailsResponse>>({ url: cards.updateLabel(request.cardId), signal, data: request });

  static updateCreditLimit = ({ cardUUId, ...data }: UpdateCreditLimitRequest, signal?: AbortSignal) =>
    this.put<Omit<UpdateCreditLimitRequest, 'cardUUId'>, ApiResponse<CreditLimitsResponse>>({ url: cards.updateCreditLimit(cardUUId), data, signal });

  static updateDebitLimit = ({ cardUUId, ...data }: UpdateDebitLimitRequest, signal?: AbortSignal) =>
    this.put<Omit<UpdateDebitLimitRequest, 'cardUUId'>, ApiResponse<UpdateDebitLimitResponse>>({
      url: cards.updateDebitLimit(cardUUId),
      data,
      signal,
    });

  static updateCategoryCard = (request: UpdateCategoryCardRequest, signal?: AbortSignal) =>
    this.put<UpdateCategoryCardRequest, ApiResponse<CardDetailsResponse>>({ url: cards.updateCategory(request.cardId), signal, data: request });

  static activate = (cardId: number, signal?: AbortSignal) => this.put<null, ApiResponse<null>>({ url: cards.activate(cardId), signal });

  static reportLostStolen = (request: ReportLostStolenRequest, signal?: AbortSignal) =>
    this.post<ReportLostStolenRequest, ApiResponse<CardDetailsResponse>>({ url: cards.reportLostStolen(request.cardId), data: request, signal });

  static backgroundTasks = (taskId: string) =>
    this.get<ApiResponse<BackgroundTasksResponse>>({ url: cards.backgroundTasks(), queryParams: { TaskId: taskId } });
}
